// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { VOTING_STATUS_CHANNELS } from "@sequentech/ui-core";
export var toVotesPerDayChartData = function (data) {
    var _a;
    var buckets = Array.from(new Set(data.map(function (_a) {
        var bucket = _a.bucket, day = _a.day;
        return String(bucket !== null && bucket !== void 0 ? bucket : day);
    }))).sort();
    var counts = new Map();
    for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
        var _b = data_1[_i], bucket = _b.bucket, day = _b.day, channel = _b.channel, day_count = _b.day_count;
        var key = "".concat(String(bucket !== null && bucket !== void 0 ? bucket : day), ":").concat(channel);
        counts.set(key, ((_a = counts.get(key)) !== null && _a !== void 0 ? _a : 0) + day_count);
    }
    var series = VOTING_STATUS_CHANNELS.map(function (channel) { return ({
        channel: channel,
        data: buckets.map(function (bucket) { var _a; return (_a = counts.get("".concat(bucket, ":").concat(channel))) !== null && _a !== void 0 ? _a : 0; }),
    }); }).filter(function (_a) {
        var channelData = _a.data;
        return channelData.some(function (count) { return count > 0; });
    });
    return { buckets: buckets, series: series };
};
